import { intlFormatPropTypes } from "react-intl";
import { howDidYouHeardOptionBaseValues, HowDidYouHeardOptionType, howDidYouHearModalMessages, isHowDidYouHeardOptionKey, OTHER_ANSWER_PREFIX } from "../../../app-profile/HowDidYouHearModal";
import { shuffle } from "lodash";

const getCurrentHostHearFromValues = (hostHeardFrom: string[]) => hostHeardFrom.reduce<HowDidYouHeardOptionType>(
    (accumulator, savedOption) => {
      if (isHowDidYouHeardOptionKey(savedOption)) {
        return { ...accumulator, [savedOption]: true };
      }

      if (savedOption.startsWith(OTHER_ANSWER_PREFIX)) {
        return {
          ...accumulator,
          Other: true,
          otherDetail: savedOption.slice(OTHER_ANSWER_PREFIX.length),
        };
      }

      // An answer we no longer offer — ignore rather than crash.
      return accumulator;
    },
    { ...howDidYouHeardOptionBaseValues },
  )

const createHoseHearFromOptionsFromTranslations = (intl: intlFormatPropTypes) =>
      shuffle(
        Object.values(howDidYouHearModalMessages).map((message) =>
          intl.formatMessage(message),
        ),
      )


export {createHoseHearFromOptionsFromTranslations, getCurrentHostHearFromValues}